import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ServiceOverview from './components/ServiceOverview';
import Benefits from './components/Benefits';
import Trust from './components/Trust';
import UseCases from './components/UseCases';
import OrderFlow from './components/OrderFlow';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import PaperRequestForm from './components/PaperRequestForm';
import InquiryForm from './components/InquiryForm';
import Footer from './components/Footer';
import AlertModal from './components/AlertModal';

export default function Home() {
  const [showPaperRequestForm, setShowPaperRequestForm] = useState(false);
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const handlePaperRequestClick = () => {
    setShowPaperRequestForm(true);
  };

  const handleInquiryClick = () => {
    setShowInquiryForm(true);
  };

  const handleClosePaperRequestForm = () => {
    setShowPaperRequestForm(false);
  };

  const handleCloseInquiryForm = () => {
    setShowInquiryForm(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header 
        onPaperRequestClick={handlePaperRequestClick}
        onInquiryClick={handleInquiryClick}
      />
      <Hero onContactClick={handlePaperRequestClick} onInquiryClick={handleInquiryClick} />
      <ServiceOverview />
      <Benefits />
      <Trust />
      <UseCases />
      <OrderFlow />
      <FAQ />
      <CTA onContactClick={handlePaperRequestClick} onInquiryClick={handleInquiryClick} />
      <Footer />
      
      {showPaperRequestForm && (
        <PaperRequestForm onClose={handleClosePaperRequestForm} setIsAlertOpen={setIsAlertOpen} />
      )}
      
      {showInquiryForm && (
        <InquiryForm onClose={handleCloseInquiryForm} setIsAlertOpen={setIsAlertOpen} />
      )}

      <AlertModal isOpen={isAlertOpen} onClose={() => setIsAlertOpen(false)} />
    </div>
  );
}
